module.exports = __webpack_public_path__ + "img/tr.21138337.png";